export const expiredStudentIdEmail = {
  hu: {
    subject: 'A diákigazolványod érvényessége le fog járni 1 hónapon belül',
    html: `
  Kedves {workerName},

  A diákigazolványod érvényessége le fog járni 1 hónapon belül, kérlek frissítsd amint tudod és töltsd fel a Della App-on keresztül!

  Köszönöm!

  Üdv,
  Della Diák Hero

  Az alkalmazáson belüli csevegőn keresztül érhetsz el!
    `,
  },
  en: {
    subject: 'Your Student ID will expire within one month',
    html: `
  Dear {workerName},

  Your Student ID will expire within one month. Please update it as soon as you can and upload it through the Della App!

  Thank you,

  Cheers,
  Della Student Hero

  You can reach me through the in-app chat!
    `,
  },
};
